import { useState, useEffect } from 'preact/hooks'
import { QUERY_MAPPING } from 'libs/search-native/search-native-utils'
import { isLoading, filters, selectedValues, activeFilters } from 'snippets/plp-native/@store'
import { handleize } from 'helpers/utils'
import AccordionItem from 'snippets/accordion-item/accordion-item'
import PlpNativeFilterGroup from 'snippets/plp-native/plp-native-filter/plp-native-filter-group'
import PlpNativeSkeletonList from 'snippets/plp-native/plp-native-skeleton/plp-native-skeleton-list'

function PlpNativeFilterList({ setLocalSelected, isDesktop }) {
  if (isLoading.value) return <PlpNativeSkeletonList />

  const [selected, setSelected] = useState(selectedValues.value)
  const [currentAccordionIndex, setCurrentAccordionIndex] = useState(null)
  const labelFilterSeoHidden = `${QUERY_MAPPING.filter.code}${QUERY_MAPPING.seo.code}`

  const getLocalSelected = (field, values, prefix) => {
    setSelected((prevState) => {
      let newValues = values

      if (prefix && prefix !== '') {
        newValues = [...(prevState[field] ?? [])]
          .filter((item) => !String(item.value).startsWith(prefix))
          .concat(values)
      }

      return {
        ...prevState,
        [field]: newValues
      }
    })
  }

  useEffect(() => {
    if (setLocalSelected) setLocalSelected(selected)
  }, [selected])

  useEffect(() => {
    !activeFilters.value && setCurrentAccordionIndex(null)
  }, [activeFilters.value])

  if (!filters.value.length) {
    return null
  }

  return (
    <>
      {filters.value.map(
        (filter, index) =>
          filter.field !== labelFilterSeoHidden && (
            <AccordionItem
              key={handleize(filter.label)}
              filter={filter}
              currentAccordionIndex={currentAccordionIndex}
              setCurrentAccordionIndex={setCurrentAccordionIndex}
              accordionIndex={index}
              heading={filter.label}
              titleClass="pb-0 capitalize text-xs text-neutral-900"
              wrapperClass="border-b border-neutral-900 last:border-0"
              itemDescriptionClass="overflow-y-auto h-full"
              maxHeightContent={400}
              content={
                <PlpNativeFilterGroup
                  key={filter}
                  field={filter}
                  getLocalSelected={getLocalSelected}
                  isDesktop={isDesktop}
                />
              }
            />
          )
      )}
    </>
  )
}

export default PlpNativeFilterList
